import { colors } from './foundation/colors';

/**
 * Global styles injected by Chakra’s system (`defineConfig.globalCss`).
 * @see https://chakra-ui.com/docs/theming/overview#globalcss
 */
export const globalCss = {
  'html, body': {
    userSelect: 'none',
    _focusVisible: { boxShadow: 'none' },
    bg: 'secondary',
    color: 'body',
  },
  select: {
    colorScheme: 'dark',
  },
  'select option': {
    backgroundColor: `${colors.dark} !important`,
    color: `${colors.body} !important`,
  },
} as const;
